import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthStore } from "../store/useAuthStore";

export const useLogoutConfirmation = () => {
  const navigate = useNavigate();
  const logout = useAuthStore((state) => state.logout);
  const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState(false);

  const requestLogout = useCallback(() => {
    setIsLogoutDialogOpen(true);
  }, []);

  const closeLogoutDialog = useCallback(() => {
    setIsLogoutDialogOpen(false);
  }, []);

  const confirmLogout = useCallback(async () => {
    try {
      await logout();
      setIsLogoutDialogOpen(false);
      navigate("/");
    } catch (err) {
      console.error("Logout error:", err);
      throw err;
    }
  }, [logout, navigate]);

  return {
    isLogoutDialogOpen,
    requestLogout,
    closeLogoutDialog,
    confirmLogout,
  };
};
